import {useFormatters} from '@wallaby-ui/document';
import {useMemo} from 'react';

import {DepartmentTableRowsTypeWithTotal, InterventionsDepartmentReportDto, ReportType} from './departmenttypes';
import {reportTypeToReportChartPropMap} from './useDepartmentReportChartCategories';

export const useDepartmentReportTableData = (
  reportType: ReportType,
  reportData: InterventionsDepartmentReportDto | undefined
): DepartmentTableRowsTypeWithTotal => {
  const {t} = useFormatters();

  return useMemo(() => {
    if (!reportData) return [];

    const totalData = reportData[reportTypeToReportChartPropMap[reportType]]?.tableTotal;
    const rowData = reportData[reportTypeToReportChartPropMap[reportType]]?.tableRows ?? [];

    return [
      {
        category: t('reports.totalRow'),
        measureCount: totalData?.measureCount ?? 0,
        measureCountToHospCountPct: totalData?.measureCountToHospCountPct ?? 0,
        measureCountPer1000HospDays: totalData?.measureCountPer1000HospDays ?? 0,
        isTotalRow: true,
      },
      ...rowData.map((row) => ({
        category: String(row.category ?? 'undefined'),
        measureCount: row.measureCount,
        measureCountToHospCountPct: row.measureCountToHospCountPct,
        measureCountPer1000HospDays: row.measureCountPer1000HospDays,
        isTotalRow: false,
      })),
    ];
  }, [reportData, reportType, t]);
};
